import { schema } from 'normalizr';

const accountWebPresenceSchema = new schema.Entity(
  'accountWebPresences',
  {},
  { idAttribute: 'uuid' }
);

export default accountWebPresenceSchema;
